const Inter_500Medium = {fontFamily: 'Inter-Medium'};
const Inter_700Bold = {fontFamily: 'Inter-Bold'};
const Inter_600SemiBold = {fontFamily: 'Inter-SemiBold'};
const Inter_900Black = {fontFamily: 'Inter-Black'};

const DM_Sans_400Regular = {fontFamily: 'DMSans-Regular'};
const DM_Sans_500Medium = {fontFamily: 'DMSans-Medium'};
const DM_Sans_700Bold = {fontFamily: 'DMSans-Bold'};

export const fonts = {
  Inter_700Bold: {...Inter_700Bold},
  Inter_900Black: {...Inter_900Black},
  Inter_500Medium: {...Inter_500Medium},
  Inter_600SemiBold: {...Inter_600SemiBold},

  DM_Sans_700Bold: {...DM_Sans_700Bold},
  DM_Sans_500Medium: {...DM_Sans_500Medium},
  DM_Sans_400Regular: {...DM_Sans_400Regular},
};
